import { useEffect } from "react";
import { useCurrentWorkspace, useAddWorkspaceUsage } from "@/store";
import { db } from "@/firebase/app";
import { doc, onSnapshot, DocumentSnapshot } from "firebase/firestore";
import { WorkspaceUsage } from "@/types/workspace";

export const useListenCurrentWorkspaceUsage = () => {
    const currentWorkspace = useCurrentWorkspace();
    const addWorkspaceUsage = useAddWorkspaceUsage();
    useEffect(() => {
        if (!currentWorkspace?.id) return;

        const unsubscribe = onSnapshot(
            doc(db, "usage", currentWorkspace.id),
            (doc: DocumentSnapshot) => {
                const usage = { ...doc.data(), id: doc.id } as WorkspaceUsage;
                addWorkspaceUsage(usage);
            }
        );
        return () => unsubscribe();
    }, [currentWorkspace, addWorkspaceUsage]);
};
